// https://stackoverflow.com/a/66749303/2734665
export default function fixedEncodeURIComponent(str: string) {
  return encodeURIComponent(str).replace(/[!%'()*]/g, (c) => {
    return `%${c.charCodeAt(0).toString(16)}`;
  });
}
